import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Robot_Video3 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoRobot3 = () => {
  return (
    <>
      <ModalVideo
        id="robot-video-3"
        dataText={Robot_Video3}
        videoSrc="https://www.youtube.com/embed/TFIz3oRCSg0?si=-p9pwW6oLqPs9M5x"
        videoTitle="KUTER_STUDIO_AI_ROBOT_VIDEO_3"
      />
    </>
  );
};

export default ModalVideoRobot3;
